"use strict"

// ###################################
export const RandNum = () => {
  return Math.random() * 10000000000000000
}
